<template>
  <app-ag-grid
    title="Products"
    :columnDefs="columnDefs"
    :rowData="products"
    :loading="loading"
    :mobileCard="mobileCard"
    @refresh="fetchProducts"
    @add="onAdd"
    @row-dbl-click="
      (data) => $router.push({ path: `products/${data._id}/edit` })
    "
  />
</template>

<script>
import AppAgGrid from "@/components/common/ag-grid.vue";

export default {
  name: "ProductsPage",
  components: { AppAgGrid },

  data() {
    return {
      loading: false,

      columnDefs: [
        {
          headerName: "View",
          field: "_id",
          width: 80,
          cellRenderer: (params) => {
            return `
              <i
                class="mdi mdi-eye view-product"
                data-id="${params.data._id}"
                title="View Product"
                style="
                  cursor: pointer;
                  font-size: 18px;
                  color: #0a5a90;
                "
              ></i>
            `;
          },

          onCellClicked: (params) => {
            if (params.event.target.classList.contains("view-product")) {
              this.$router.push({ path: `products/${params.data._id}/view` });
            }
          },
        },

        {
          headerName: "Product Name",
          field: "productName",
          width: 400,
        },

        {
          headerName: "HSN Code",
          field: "hsn",
          width: 200,
        },

        {
          headerName: "Rate (₹)",
          field: "rate",
          width: 200,
          valueFormatter: (p) => {
            if (p.value == null) return "-";
            return new Intl.NumberFormat("en-IN", {
              style: "currency",
              currency: "INR",
            }).format(p.value);
          },
        },

        {
          headerName: "Stock",
          field: "stockQuantity",
          width: 180,
          valueFormatter: (p) => {
            if (!p.data.trackStock) return "—";
            const low = p.data.stockQuantity <= p.data.lowStockThreshold;
            return low ? `${p.value} ⚠ Low` : `${p.value}`;
          },
        },

        {
          headerName: "Created At",
          field: "createdAt",
          width: 200,
          valueFormatter: (p) => {
            if (!p.value) return "-";

            const date = new Date(p.value);
            const day = String(date.getDate()).padStart(2, "0");
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const year = date.getFullYear();

            return `${day}-${month}-${year}`;
          },
        },

        { headerName: "User", field: "userId.name", width: 200 },
        { headerName: "User Email", field: "userId.email", width: 300 },
      ],
    };
  },

  computed: {
    products() {
      return this.$store.state.products.products;
    },

    mobileCard() {
      return {
        title: (row) => row.productName || "-",
        subtitle: (row) => (row.hsn ? `HSN ${row.hsn}` : "-"),
        fields: (row) => [
          {
            label: "Rate",
            value: row.rate == null
              ? "-"
              : new Intl.NumberFormat("en-IN", {
                  style: "currency",
                  currency: "INR",
                }).format(row.rate),
          },
          {
            label: "Stock",
            value: !row.trackStock
              ? "—"
              : row.stockQuantity <= row.lowStockThreshold
                ? `${row.stockQuantity} ⚠ Low`
                : `${row.stockQuantity}`,
          },
        ],
        actions: (row) => [
          {
            label: "View",
            icon: "mdi-eye-outline",
            color: "#0a5a90",
            onClick: () => this.$router.push({ path: `products/${row._id}/view` }),
          },
          {
            label: "Edit",
            icon: "mdi-pencil-outline",
            color: "#475569",
            onClick: () => this.$router.push({ path: `products/${row._id}/edit` }),
          },
        ],
      };
    },
  },

  created() {
    this.fetchProducts();
  },

  methods: {
    async fetchProducts() {
      this.loading = true;
      try {
        await this.$store.dispatch("products/getProducts");
      } finally {
        this.loading = false;
      }
    },

    onAdd() {
      this.$router.push({ path: "products/create" });
    },
  },
};
</script>
